import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { vehicleSchema } from '../schemas/vehicle.schema';
import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';
import { fromFetch } from 'rxjs/fetch';

/**
 * Returns a specific Vehicle
 * @param vehicleId The ID of the Vehicle being requested
 * @returns The Vehicle
 */
export function getVehiclesId(this: unknown, vehicleId: string) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment.resolve(this).vehiclesUrl}/${vehicleId}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      vehicleSchema.extend({
        appVersion: z.string().nullable(),
        dataVersion: z.string().nullable(),
        lastConnected: z.string().nullable(),
        lastCommunicationRequest: z.string().nullable(),
        assets: z
          .array(
            z.object({
              deviceId: z.string(),
              isActive: z.boolean(),
            })
          )
          .optional()
          .nullable(),
        lastStoredTimeStamp: coercedDate.nullable(),
      })
    )
  );
}
